import React, { Component } from 'react';

import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { amber, green, red } from '@material-ui/core/colors';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';

var timer;
class CustomMsgToast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      never_shown: true,
      visible: false,
    };
    this.onClose = this.onClose.bind(this);
  }
  componentWillReceiveProps(props) {
    if (props.visible === true && this.state.visible === false) {
      clearTimeout(timer);
      this.setState({ visible: true, never_shown: true });
      timer = setTimeout(() => {
        this.setState({ visible: false, never_shown: true });
      }, 4000);
    }
    if (props.visible === true && this.state.visible === true) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.setState({ visible: false, never_shown: true });
      }, 4000);
    }
  }
  onClose() {
    this.setState({ visible: false, never_shown: false });
  }

  render() {
    const { visible, never_shown } = this.state;
    const { message, color } = this.props;
    var bgColor = amber[700];
    switch (color) {
      case 'red':
        bgColor = red[700];
        break;
      case 'green':
        bgColor = green[700];
        break;
      case 'yellow':
        bgColor = amber[700];
        break;
    }
    return (
      <Snackbar
        style={{ marginBottom: 40 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={visible && never_shown}
        autoHideDuration={6000}
        onClose={this.onClose}
      >
        <SnackbarContent
          style={{ backgroundColor: bgColor, opacity: 0.9, marginRight: 20 }}
          aria-describedby="client-snackbar"
          message={
            <span
              id="client-snackbar"
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <InfoIcon style={{ fontSize: 20, marginRight: 10 }} />
              {message ? (
                <>{message}</>
              ) : (
                <>
                  Auto-Refresh works best when&nbsp;&nbsp;<b>Time Span</b>&nbsp;&nbsp;is set to:&nbsp;&nbsp;<b>Today</b>
                  .
                </>
              )}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={this.onClose}
            >
              <CloseIcon style={{ fontSize: 20 }} />
            </IconButton>,
          ]}
        />
      </Snackbar>
    );
  }
}

export default CustomMsgToast;
